import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import QRCodeGenerator from "./Qrgenerator";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import OrganizationService from "../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";

const DetailOrganization = () => {
  const { id } = useParams(); // id is a string from URL parameters
  const [activeTab, setActiveTab] = useState("1");
  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [data, setData] = useState([]);
  console.log("🚀 ~ DetailOrganization ~ data:", data);

  const fetchDetail = async () => {
    try {
      const response = await OrganizationService.detail(id);
      setData(response);
    } catch (error) {}
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  const orgCode = data?.orgCode;
  console.log("🚀 ~ DetailOrganization ~ orgcode:", orgCode);
  const url = `${window.location.origin}/${orgCode}?source=qr-menu`;

  console.log("🚀 ~ DetailOrganization ~ url:", url);

  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <BreadCrumb
            pageTitle="Organization Management"
            title="Organization Management Detail"
            breadcrumbItems={[
              { title: "Back To List ", link: "/organization-management" },
            ]}
          />
        </div>

        <div className="position-relative mx-n4 mt-n4">
            <div
              className="profile-wid-bg profile-setting-img"
              style={{ background: "none" }}
            >
              <img
                src={data?.cloudR2BannerImagePath?.getCDNUrl()}
                className="profile-wid-img"
                alt="banner"
              />
              <div
                className="overlay-content"
                style={{ background: "transparent" }}
              >
                <div className="text-end p-3">
                  <div className="p-0 ms-auto rounded-circle profile-photo-edit">
                  </div>
                
                </div>
              </div>
            </div>
          </div>
        <Row className="mt-md-n5">
          <Col md={4} className="mb-3">
            <Card>
              <QRCodeGenerator url={url} data={data} />
            </Card>
          </Col>
          <Col md={8}>
            <Card className="p-3">
              <Row>
                <Col md={12}>
                  <Row>
                    <Col md={6}>
                      <h6>
                        Organization Management System:{" "}
                        <span
                          className={`badge ${
                            data?.hasOMS === true ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {data?.hasOMS === true ? "Enable" : "Disabled"}
                        </span>
                      </h6>
                    </Col>
                    <Col md={6}>
                      <h6>
                        Type:{" "}
                        <span
                          className={`badge ${
                            data?.isPaid === true ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {data?.isPaid === true ? "Paid" : "Unpaid"}
                        </span>
                      </h6>
                    </Col>
                  </Row>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col md={6} className="mb-2">
                      <h5 className="fw-bold">Organization Name: </h5>
                      <h6 className="fw-normal">{data?.name}</h6>
                    </Col>
                    <Col md={6} className="mb-2">
                      <h5 className="fw-bold">Organization Email:</h5>
                      <h6 className="fw-normal">{data?.email}</h6>
                    </Col>
                    <Col md={6} className="mb-2">
                      <h5 className="fw-bold">Contact Number:</h5>
                      <h6 className="fw-normal">{data?.contactNo}</h6>
                    </Col>
                    <Col md={6} className="mb-2">
                      <h5 className="fw-bold">Address 1:</h5>
                      <h6 className="fw-normal">{data?.address1}</h6>
                    </Col>
                    <Col md={6} className="mb-2">
                      <h5 className="fw-bold">Address 2:</h5>
                      <h6 className="fw-normal">{data?.address2}</h6>
                    </Col>
                    <Col md={6} className="mb-2">
                      <h5 className="fw-bold">Website:</h5>
                      <h6 className="fw-normal">{data?.website}</h6>
                    </Col>
                    <hr />
                    <Col md={12}>
                      <h5 className="fw-bold">Tag Line</h5>
                      <p>{data?.tagLine}</p>
                    </Col>
                    <hr />
                    <Col md={12}>
                      <h5 className="fw-bold">About Us</h5>
                      <p>{data?.aboutUs}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Card className="mt-md-n5">
          <CardHeader>
            <Nav
              className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
              role="tablist"
            >
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => tabChange("1")}
                >
                  <i className="fas fa-home"></i>
                  Orders
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => tabChange("2")}
                >
                  <i className="far fa-user"></i>
                  Customer
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => tabChange("3")}
                >
                  <i className="far fa-user"></i>
                  Trading Hours
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "4" })}
                  onClick={() => tabChange("4")}
                >
                  <i className="far fa-user"></i>
                  Theme
                </NavLink>
              </NavItem>
            </Nav>
          </CardHeader>

          <CardBody className="p-4">
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1"></TabPane>
              <TabPane tabId="2"></TabPane>
              <TabPane tabId="3"></TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default DetailOrganization;
